import React from 'react';
export function HeroSection() {
  return <section className="w-full bg-white py-10 md:py-16 px-4 md:px-8" data-id="element-102">
      <div className="max-w-6xl mx-auto text-center" data-id="element-103">
        <h1 className="font-black text-3xl md:text-4xl lg:text-5xl leading-tight mb-6 text-[#1a1a2e]" data-id="element-104">
          Does your child spend{' '}
          <span className="text-[#1a56db]" data-id="element-105">countless hours</span> in front of a
          screen and look at you with{' '}
          <span className="text-[#1a56db]" data-id="element-106">disdain</span> when you stand firm?
        </h1>
        <p className="text-lg md:text-xl lg:text-2xl text-[#1a1a2e] leading-relaxed" data-id="element-107">
          Stop the yelling, end the fights over screens, and{' '}
          <span className="font-bold" data-id="element-108">
            regain control of your child's brain
          </span>{' '}
          in exactly 20 minutes, without being "the bad guy."
        </p>
      </div>
    </section>;
}